var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 22,
    viewBox: "0 0 18 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.52016 14.59H10.5425V21.3825H7.52016V14.59Z",
    fill: "#43E660"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.531962 7.63631H5.66763L2.01117 4.17545L4.02606 2.12221L7.50481 5.68023V0.617432H10.5271V5.67895L14.0046 2.12093L16.0195 4.17417L12.3631 7.63503H17.5V10.4976H12.3311L16.0042 14.0556L13.9893 16.0615L8.99936 11.0639L4.00944 16.0615L1.99455 14.0556L5.66763 10.4976H0.5V7.63631H0.531962Z",
    fill: "#43E660"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenLogo);
export default __webpack_public_path__ + "static/media/green-logo.8218539b71533789dea610c8e0897c83.svg";
export { ForwardRef as ReactComponent };